import React, { Component, Fragment } from 'react';
import { render } from 'react-dom';
import VacationDates from './VacationDates';
import OptionalControls from './OptionalControls';
import { VacationProvider, VacationContext } from 'js/components/step1/VacationContext';
import Loader from 'js/components/global/Loader';
import ErrorBoundary from 'js/components/global/ErrorBoundary';
import Countdown from 'js/components/global/countdown/Countdown';

class Vacation extends Component {

  state = {
    hasRoundtrip: false,
  };

  render() {
    return(
      <ErrorBoundary>
        <VacationProvider>
          <VacationContext.Consumer>
            {(context) => {
              if (context.state.isLoading || _app.urlparams.BYPASSFORM) {
                if(context.state.vacationResponse.code === undefined || context.state.vacationResponse.code === 1) {
                  return (
                    <Fragment>
                      <div className="loader-cover">
                        <Loader />
                      </div>
                      <div className="loader-section" />
                    </Fragment>
                  );
                }
              }

              return (
                <Fragment>
                  <VacationDates />
                  <OptionalControls hasGroup={context.state.hasGroup} hasSSG={context.state.hasSSG} />
                  <Countdown />
                </Fragment>
              );
            }}
          </VacationContext.Consumer>
        </VacationProvider>
      </ErrorBoundary>
    );
  }
}

if (!module.hot) {
  render(
    <Vacation />,
    document.querySelector('#root')
  );
}

export default Vacation;



// WEBPACK FOOTER //
// ./js/views/step1/Vacation.js